var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InscriptionsList',{attrs:{"estados":['PAGO_REALIZADO', 'PAGO_BONIFICADO', 'pago_no_paga']}})
}
var staticRenderFns = []

export { render, staticRenderFns }